module.exports = __webpack_public_path__ + "img/go-build-logo.db95da76.jpg";